import React, { useEffect, useState } from 'react';
import { completeModule } from '../../../requests/learning';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { CompleteResponse } from './types';
import Icon from 'lqa-ui/lib/Components/Icon';
import { round } from 'lodash';
import { WrapperResult, StarsContainer } from './Quizzes.styled';
import { Body4, Headline2 } from './../../../app/common/typography';
import { Star } from './../../../app/common/icons/Star';

const STAR_MAX_RATE = 5;

const Results = ({ module, questionsCount, score }) => {
  const [completeModuleResponse, setCompleteModuleResponse] =
    useState<CompleteResponse>();
  const [starRating, setStarRating] = useState<number>(-1);
  const [isOddScore, setIsOddScore] = useState(false);
  useEffect(() => {
    (async () => {
      const { data } = await completeModule(module.id, round(score, 1));
      setCompleteModuleResponse(data);
      const fiveScoreScale = score * 5;
      setIsOddScore(!Number.isSafeInteger(fiveScoreScale));
      setStarRating(Math.floor(fiveScoreScale));
    })();
  }, []);

  if (!completeModuleResponse) {
    return <LoadingContent layout="flex" />;
  }

  return (
    <WrapperResult>
      <Headline2 color="darkBlue">
        You have scored {Math.round(score * 10)} out of {questionsCount}
      </Headline2>
      <StarsContainer>
        {[...Array(starRating)].map((e, i) => (
          <Icon key={i} kind="star" width={36} height={36} />
        ))}
        {isOddScore && <Star />}
        {[...Array(STAR_MAX_RATE - (starRating + (isOddScore ? 1 : 0)))].map(
          (e, i) => (
            <Icon
              key={`border-${i}`}
              kind="star-empty"
              width={36}
              height={36}
            />
          )
        )}
      </StarsContainer>
      <Body4>
        {completeModuleResponse.assignmentPassed
          ? 'Well done! You have learned some practical lessons that will help you provide a better service experience to your hotel guests.'
          : 'You have not met the minimum requirements to pass. Please review the video thoroughly and try taking the test again.'}
      </Body4>
    </WrapperResult>
  );
};

export default Results;
